import { mapGetters } from "vuex";
import * as types from "@/store/types";

export default {
  name: "currency-filter-input",
  components: {},
  props: {
    currency: {
      type: Array
    }
  },
  data() {
    return {
      search: "",
      showModal: false
    };
  },
  computed: {
    ...mapGetters({
      getCurrencies: types.currencies.getters.GET_CURRENCIES
    }),
    computedCurrency: {
      get() {
        return this.currency;
      },
      set(newValue) {
        this.$emit("onUpdate", { currency: newValue });
      }
    },
    currenciesList() {
      return [...this.getCurrencies];
    },
    transactionsCategory() {
      return this.$route.query.category;
    },
    filterResult() {
      if (this.currenciesList) {
        return this.currenciesList.filter(elem => {
          return (
            elem.name_locale
              .replace(/[^\p{L}]/gu, "")
              .includes(this.search.toLowerCase().replace(/[^\p{L}]/gu, "")) ||
            elem.name
              .replace(/[^\p{L}]/gu, "")
              .toLowerCase()
              .includes(this.search.toLowerCase().replace(/[^\p{L}]/gu, "")) ||
            elem.iso
              .replace(/[^\p{L}]/gu, "")
              .toLowerCase()
              .includes(this.search.toLowerCase().replace(/[^\p{L}]/gu, ""))
          );
        });
      }
    }
  },
  mounted() {},
  methods: {
    clickOnModalFromCurrency(value) {
      this.computedCurrency = value.iso;
      this.search = "";
      this.showModal = false;
    },
    closeModal() {
      this.$refs.searchModal.scrollTop = 0;
      this.showModal = false;
      this.search = "";
    },
    onFocusInput() {
      this.$emit("onFocus", true);
    },
    onBlurInput() {
      this.$emit("onBlur", false);
    }
  }
};
